import { useMemo } from "react";

/**
 * Componente reutilizable de filtros Categoría + Subcategoría.
 * Subcategoría se habilita solo cuando la categoría seleccionada tiene hijas.
 * Al cambiar categoría, subcategoría se limpia automáticamente.
 *
 * Props:
 *  - categorias: Array de { id, nombre }
 *  - subcategorias: Array de { id, nombre, categoria_id, orden }
 *  - filtroCategoria: string (valor actual)
 *  - filtroSubcategoria: string (valor actual)
 *  - onCategoriaChange: (value: string) => void
 *  - onSubcategoriaChange: (value: string) => void
 *  - className: string (clase CSS para los selects, default "form-select")
 *  - activeClass: string (clase CSS cuando filtro activo)
 */
export const CategoriaSubcategoriaFilter = ({
  categorias = [],
  subcategorias = [],
  filtroCategoria,
  filtroSubcategoria,
  onCategoriaChange,
  onSubcategoriaChange,
  className = "form-select",
  activeClass = "",
}) => {
  const subcategoriasFiltered = useMemo(() => {
    if (!filtroCategoria) return [];
    return subcategorias
      .filter((s) => String(s.categoria_id) === String(filtroCategoria))
      .sort((a, b) => a.orden - b.orden);
  }, [subcategorias, filtroCategoria]);

  const hasSubcategorias = subcategoriasFiltered.length > 0;

  return (
    <>
      <div>
        <select
          className={`${className} ${filtroCategoria ? activeClass : ""}`}
          value={filtroCategoria}
          onChange={(e) => {
            onCategoriaChange(e.target.value);
            onSubcategoriaChange("");
          }}
        >
          <option value="">Categoría</option>
          {[...categorias]
            .sort((a, b) => a.nombre.localeCompare(b.nombre))
            .map((cat) => (
              <option key={cat.id} value={cat.id}>
                {cat.nombre}
              </option>
            ))}
        </select>
      </div>
      <div>
        <select
          className={`${className} ${filtroSubcategoria ? activeClass : ""}`}
          value={filtroSubcategoria}
          onChange={(e) => onSubcategoriaChange(e.target.value)}
          disabled={!filtroCategoria || !hasSubcategorias}
        >
          <option value="">Subcategoría</option>
          {subcategoriasFiltered.map((sub) => (
            <option key={sub.id} value={sub.id}>
              {sub.nombre}
            </option>
          ))}
        </select>
      </div>
    </>
  );
};
